var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4813 6.3008V8.78973C13.0025 7.99579 13.7209 7.35078 14.5662 6.91784C15.4115 6.48489 16.3548 6.27885 17.3037 6.31987C22.371 6.31987 23.4666 9.48787 23.4666 13.6092V22H18.7733V14.5611C18.7733 12.7864 18.4154 10.5043 15.6522 10.5043C12.9726 10.5043 12.515 12.4359 12.515 14.4291V22H7.83632V6.3008H12.4813ZM4.69325 2.35547C4.69267 2.8204 4.55486 3.27483 4.29708 3.66176C4.0393 4.04869 3.67302 4.35091 3.24418 4.53053C2.81552 4.70871 2.34354 4.75531 1.8883 4.66442C1.43307 4.57353 1.01517 4.34926 0.687784 4.02013C0.359788 3.69081 0.136486 3.27185 0.0459597 2.81595C-0.0445664 2.36005 0.00172554 1.88757 0.179013 1.45791C0.356301 1.02825 0.656669 0.660597 1.04235 0.401191C1.42802 0.141785 1.88179 0.00220353 2.34658 0C2.6555 -2.17198e-06 2.96137 0.0609863 3.24665 0.179467C3.53194 0.297948 3.79102 0.47159 4.00905 0.690431C4.22707 0.909272 4.39974 1.16901 4.51715 1.45473C4.63457 1.74046 4.69441 2.04656 4.69325 2.35547Z",
    fill: "#005F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69333 6.31982H0V22H4.69333V6.31982Z",
    fill: "#005F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlue);
export default __webpack_public_path__ + "static/media/Linkedin_Blue.ab101bc98e21b5bb1efff2d986906de8.svg";
export { ForwardRef as ReactComponent };